import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import NodoCircuito from './NodoCircuito';
import colores from '../Bandeja/coloresBandeja';

const ANCHO_NODO = '340px';

const useStyles = makeStyles((theme) => ({
  contenedor: {
    overflowX: 'auto',
    paddingBottom: '6px'
  },
  arbol: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& ul': {
      listStyle: 'none',
      margin: 0,
      paddingLeft: '28px'
    },
    '& li': {
      position: 'relative',
      paddingTop: '8px'
    },
    // Conectores: línea vertical desde el padre y horizontal hasta el nodo.
    '& ul > li::before': {
      content: '""',
      position: 'absolute',
      left: '-16px',
      top: 0,
      bottom: 0,
      borderLeft: `2px solid ${colores.borde}`
    },
    '& ul > li:last-child::before': {
      bottom: 'auto',
      height: '30px'
    },
    '& ul > li::after': {
      content: '""',
      position: 'absolute',
      left: '-16px',
      top: '30px',
      width: '14px',
      borderTop: `2px solid ${colores.borde}`
    },
    // En celular menos sangría por nivel para que el árbol entre a lo ancho.
    [theme.breakpoints.down('xs')]: {
      '& ul': {
        paddingLeft: '16px'
      },
      '& ul > li::before': {
        left: '-10px'
      },
      '& ul > li::after': {
        left: '-10px',
        width: '8px'
      }
    }
  },
  // El comprobante y, a su derecha, la columna con sus recibos.
  fila: {
    display: 'flex',
    alignItems: 'flex-start',
    // En celular los recibos van debajo, como una rama más.
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  nodo: {
    width: ANCHO_NODO,
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
      minWidth: 0
    }
  },
  recibos: {
    position: 'relative',
    marginTop: '-8px !important',
    // Línea desde el comprobante hasta la columna de recibos.
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '22px',
      width: '12px',
      borderTop: `2px solid ${colores.borde}`
    },
    '& > li': {
      width: ANCHO_NODO
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '0 !important',
      '&::before': {
        display: 'none'
      },
      '& > li': {
        width: 'auto'
      }
    }
  }
}));

const Rama = ({ circuito, nodo, enlace, esRaiz, camino, classes }) => {
  // camino evita un loop infinito si los datos tuvieran un ciclo.
  const hijos = circuito.hijos(nodo.clave).filter((hijo) => !camino.includes(hijo.nodo.clave));
  const recibos = hijos.filter((hijo) => hijo.nodo.esRecibo);
  const otros = hijos.filter((hijo) => !hijo.nodo.esRecibo);

  return (
    <li>
      <div className={classes.fila}>
        <div className={classes.nodo}>
          <NodoCircuito nodo={nodo} enlace={enlace} esRaiz={esRaiz} circuito={circuito} />
        </div>
        {recibos.length > 0 && (
          <ul className={classes.recibos}>
            {recibos.map((recibo) => (
              <li key={recibo.nodo.clave}>
                <NodoCircuito nodo={recibo.nodo} enlace={recibo.enlace} circuito={circuito} />
              </li>
            ))}
          </ul>
        )}
      </div>
      {otros.length > 0 && (
        <ul>
          {otros.map((hijo) => (
            <Rama
              key={hijo.nodo.clave}
              circuito={circuito}
              nodo={hijo.nodo}
              enlace={hijo.enlace}
              camino={[...camino, hijo.nodo.clave]}
              classes={classes}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

/**
 * El comprobante arriba y cada uno que lo descargó debajo (si uno descarga a varios aparece bajo cada uno). Los
 * recibos que pagan una factura se abren a su derecha, en columna.
 */
const CircuitoArbol = ({ circuito }) => {
  const classes = useStyles();

  return (
    <div className={classes.contenedor}>
      <ul className={classes.arbol}>
        <Rama circuito={circuito} nodo={circuito.raiz} esRaiz camino={[circuito.raiz.clave]} classes={classes} />
      </ul>
    </div>
  );
};

export default CircuitoArbol;
